import { useId } from 'react'

/** Aivy brand mark (assets/logo.svg inlined). The one place the spectrum gradient
 *  appears in chrome — it is the brand, not a UI state (design §16 covers components).
 *  The gradient id is per instance: the shell renders the mark twice (rail + phone top bar)
 *  and a url(#id) that resolves into the display:none copy paints nothing. */
export function Logo({ size = 28 }: { size?: number }) {
  const gradientId = `aivy-spectrum-${useId().replace(/:/g, '')}`
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label="Aivy"
      style={{ flexShrink: 0 }}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#19E0FF" />
          <stop offset="52%" stopColor="#6E5BFF" />
          <stop offset="100%" stopColor="#FF35C8" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="508" height="508" rx="112" fill="var(--void)" stroke="var(--hairline)" strokeWidth="6" />
      <path
        className="nh-beam"
        d="M140 384 L256 128 L372 384"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="58"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M196 300 L316 300" fill="none" stroke="var(--ink-1)" strokeOpacity="0.85" strokeWidth="30" strokeLinecap="round" />
      <circle cx="256" cy="128" r="12" fill="#FFFFFF" opacity="0.92" />
    </svg>
  )
}
